import React from 'react';

import { noop } from 'lodash';
import { useParams } from 'react-router-dom';

import { CreateCardModal } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/CreateCardModal/CreateCardModal';
import { IInitialCard } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/CreateCardModal/CreateCardModal.types';
import { useMainCardProvider } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/MainCard.provider';
import { ProgramActivityCardModal } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCardModal/ProgramActivityCardModal';
import { RecommendationCardModal } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/RecommendationCardModal/RecommendationCardModal';
import { UserActionCardModal } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/UserActionCardModal/UserActionCardModal';

interface IMainCardProps {
    saveCardCallback?: (value?: number) => void;
    deleteCardCallback?: (value?: number) => void;
    initialCard?: IInitialCard;
    queryKeys?: string[];
}

export const MainCard = ({
    saveCardCallback = noop,
    deleteCardCallback = noop,
    initialCard,
    queryKeys = [],
}: IMainCardProps) => {
    const { cardId } = useParams<{ cardId: string }>();

    const { api } = useMainCardProvider();

    const data = api.getCard.data;

    const cardType = data?.type.name;

    return (
        <>
            {cardId === 'newCard' && <CreateCardModal saveCardCallback={saveCardCallback} initialCard={initialCard} />}
            {cardType === 'USER_GENERATED' && (
                <UserActionCardModal
                    saveCardCallback={saveCardCallback}
                    deleteCardCallback={deleteCardCallback}
                    queryKeys={queryKeys}
                />
            )}
            {cardType === 'KC_INSIGHT' && (
                <RecommendationCardModal
                    saveCardCallback={saveCardCallback}
                    deleteCardCallback={deleteCardCallback}
                    queryKeys={queryKeys}
                />
            )}
            {cardType === 'PROGRAMME_ACTIVITY' && (
                <ProgramActivityCardModal saveCardCallback={saveCardCallback} queryKeys={queryKeys} />
            )}
        </>
    );
};
